import Vue from 'vue';

// simple vue object as event bus
export default new Vue();


// WEBPACK FOOTER //
// ./src/helper/event-bus.js